import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { VENDOR_REQUEST_LIST,VENDOR_ONBOARDED_LIST,VENDOR_PAYMENT_ADD,PO_DETAIL,PAYMENT_LIST,VENDOR_PAYMENT_DETAIL,PAYMENT_REQUEST_LIST,VENDOR_PAYMENT_REQUEST_DETAIL ,FILTER_LIST,INVOICE_REQUEST_DETAILS,INVOICE_REQUEST_LIST,REQUEST_INVOICE_REQUEST_DETAILS,VENDOR_DEPARTMENT, GET_VENDOR_DEPARTMENTS, ADD_VENDOR_ADVANCES} from "./type";

export const getVendorRequestList = (queryObj = null, page = 1) => async (dispatch) => {

  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `&site_no=${queryObj.site_no}&status=${queryObj.leadStatus}&client_name=${queryObj.client_name}&page=${page}`;
  }
  try {
   
    let apiUrl = queryObj
        ? `${Config.preSalesList.vendorRequestList}?lead_type=1${filterQuery}`
        : `${Config.preSalesList.vendorRequestList}?lead_type=1&page=${page}`;

    dispatch({
      type: VENDOR_REQUEST_LIST,
      payload: {},
    });
    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: VENDOR_REQUEST_LIST,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: VENDOR_REQUEST_LIST,
      payload: {},
    });
  }
};
export const getVendorRequestListSearch = (searchKey = null, page = 1) => async (dispatch) => {

  let filterQuery = "";
  if (searchKey !== null) {
    filterQuery = `&searchKey=${searchKey}&page=${page}`;
  }
  try {
   
    let apiUrl = searchKey
        ? `${Config.preSalesList.vendorRequestList}?lead_type=1${filterQuery}`
        : `${Config.preSalesList.vendorRequestList}?lead_type=1&page=${page}`;

    dispatch({
      type: VENDOR_REQUEST_LIST,
      payload: {},
    });
    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: VENDOR_REQUEST_LIST,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: VENDOR_REQUEST_LIST,
      payload: {},
    });
  }
};

export const vendorEditRequest = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.preSalesList.vendorEditRequest
  );
  if (res?.data?.response?.status) {
    return true;
  }
  return false;
};

export const getVendorRequestSubmit = (requestData) => async()=>{
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.preSalesList.addVendorRequest
  );
  if (res?.data?.response.status === true) {
    // const { data } = res;
    return true;
  }
};

export const getDepartment = () => async(dispatch)=>{
  console.log('aa')
  const res = await callWebService(
    callTypes.get,
    '',
    Config.preSalesList.getDepartment
  );
  if (res?.data?.response.status === true) {
    console.log(res?.data?.response)
    const { data } = res;
      dispatch({
        type: VENDOR_DEPARTMENT,
        payload: data.response.data,
      });
      return true;
  }else{
    dispatch({
      type: VENDOR_DEPARTMENT,
      payload: {},
    });
  }
};

export const getVendorOnboardingList = (queryObj = null, page = 1, isPending = false, vendor_id = '') => async (dispatch) => {

  let filterQuery = "";
  const pendingFlag = isPending ? 1 : 0;
  if (queryObj !== null) {
    filterQuery = `&site_no=${queryObj.site_no}&status=${queryObj.leadStatus}&client_name=${queryObj.client_name}&page=${page}`;
  }
  try {
   
    let apiUrl = queryObj
        ? `${Config.preSalesList.vendorOnboardedList}?lead_type=1${filterQuery}&isPending=${pendingFlag}`
        : `${Config.preSalesList.vendorOnboardedList}?lead_type=1&page=${page}&isPending=${pendingFlag}&vendor_id=${vendor_id}`;

    dispatch({
      type: VENDOR_ONBOARDED_LIST,
      payload: {},
    });
    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: VENDOR_ONBOARDED_LIST,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: VENDOR_ONBOARDED_LIST,
      payload: {},
    });
  }
};
export const getVendorOnboardedListSearch = (searchKey = null, page = 1, isPending = false) => async (dispatch) => {

  let filterQuery = "";
  const pendingFlag = isPending ? 1 : 0;
  if (searchKey !== null) {
    filterQuery = `&searchKey=${searchKey}&page=${page}`;
  }
  try {
   
    let apiUrl = searchKey
        ? `${Config.preSalesList.vendorOnboardedList}?lead_type=1${filterQuery}&isPending=${pendingFlag}`
        : `${Config.preSalesList.vendorOnboardedList}?lead_type=1&page=${page}&isPending=${pendingFlag}`;

    dispatch({
      type: VENDOR_ONBOARDED_LIST,
      payload: {},
    });
    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: VENDOR_ONBOARDED_LIST,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: VENDOR_ONBOARDED_LIST,
      payload: {},
    });
  }
};

export const getPaymentRequestDetails = (vendorId) => async (dispatch) => {

 
  try {
   
    let apiUrl = `${Config.preSalesList.getPaymentRequestDetails}?vendorId=${vendorId}`;

    dispatch({
      type: VENDOR_PAYMENT_ADD,
      payload: {},
    });
    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: VENDOR_PAYMENT_ADD,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: VENDOR_PAYMENT_ADD,
      payload: {},
    });
  }
};

export const getVendorPo = (vendorId,po_no) => async (dispatch) => {

 
  try {
   
    let apiUrl = `${Config.preSalesList.getVendorPO}?vendorId=${vendorId}&po_no=${po_no}`;

    dispatch({
      type: PO_DETAIL,
      payload: {},
    });
    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: PO_DETAIL,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: PO_DETAIL,
      payload: {},
    });
  }
};

export const saveVendorPayment = (requestData) => async()=>{
  // console.log(request);
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.preSalesList.saveVendorPayment
  );
  if (res?.data?.response.status === true) {
    // const { data } = res;
    return true;
  }
};

export const approveVendor = (requestData) => async()=>{
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.preSalesList.approveVendor
  );
  if (res?.data?.response.status === true) {
    return true;
  }
  else{
    return false;
  }
};

export const addVendorAdvance = (requestData) => async()=>{
  // console.log(request);
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.preSalesList.addVendorAdvance
  );
  console.log("RESR: ", res)
  if (res?.data?.status === true) {
    // const { data } = res;
    return true;
  }
};

export const invoiceModificationRequest = (requestData) => async()=>{
  // console.log(request);
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.preSalesList.invoiceModificationRequest
  );
  if (res?.data?.response.status === true) {
    // const { data } = res;
    return true;
  }
};

export const getVendorPaymentList = (queryObj = null, page = 1) => async (dispatch) => {

  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `&site_no=${queryObj.site_no}&status=${queryObj.leadStatus}&client_name=${queryObj.client_name}&page=${page}`;
  }
  try {
   
    let apiUrl = queryObj
        ? `${Config.preSalesList.vendorPaymentList}?lead_type=1${filterQuery}`
        : `${Config.preSalesList.vendorPaymentList}?lead_type=1&page=${page}`;

    dispatch({
      type: PAYMENT_LIST,
      payload: {},
    });
    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: PAYMENT_LIST,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: PAYMENT_LIST,
      payload: {},
    });
  }
};
export const getVendorPaymentListSearch = (searchKey = null, page = 1) => async (dispatch) => {

  let filterQuery = "";
  if (searchKey !== null) {
    filterQuery = `&searchKey=${searchKey}&page=${page}`;
  }
  try {
   
    let apiUrl = searchKey
        ? `${Config.preSalesList.vendorPaymentList}?lead_type=1${filterQuery}`
        : `${Config.preSalesList.vendorPaymentList}?lead_type=1&page=${page}`;

    dispatch({
      type: PAYMENT_LIST,
      payload: {},
    });
    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: PAYMENT_LIST,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: PAYMENT_LIST,
      payload: {},
    });
  }
};

export const vendorPaymentDetails = (payment_id) => async (dispatch) => {

 
  try {
   
    let apiUrl = `${Config.preSalesList.vendorPaymentDetails}?payment_id=${payment_id}`;

    dispatch({
      type: VENDOR_PAYMENT_DETAIL,
      payload: {},
    });
    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: VENDOR_PAYMENT_DETAIL,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: VENDOR_PAYMENT_DETAIL,
      payload: {},
    });
  }
};

// savePaymentRequest
export const savePaymentRequest = (requestData) => async()=>{
  // console.log(requestData); return false;
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.preSalesList.saveVendorPaymentRequest
  );
  if (res?.data?.response.status === true) {
    // const { data } = res;
    return true;
  }
};

export const getVendorPaymentRequestList = (queryObj = null, page = 1, show_hold = 0,approve=0) => async (dispatch) => {

  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `&vendor_name=${queryObj.vendor_name}&invoice_number=${queryObj.invoice_number}&status=${queryObj.status_id}&fromDate=${queryObj.fromDate}&toDate=${queryObj.toDate}&page=${page}&approve=${approve}`;
  }
  try {
   
    let apiUrl = queryObj
        ? `${Config.preSalesList.getVendorPaymentRequestList}?lead_type=1${filterQuery}`
        : `${Config.preSalesList.getVendorPaymentRequestList}?lead_type=1&page=${page}&show_hold=${show_hold}&approve=${approve}`;

    dispatch({
      type: PAYMENT_REQUEST_LIST,
      payload: {},
    });
    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: PAYMENT_REQUEST_LIST,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: PAYMENT_REQUEST_LIST,
      payload: {},
    });
  }
};

export const getListFilterData = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.listFilterData.fillterVendorDropdown}?stage=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: FILTER_LIST, payload: data.response ?? { data: data.data } });
    return true;
  }
};

// getVendorPaymentRequestDetail
export const getVendorPaymentRequestDetail = (payment_id) => async (dispatch) => {

 
  try {
   
    let apiUrl = `${Config.preSalesList.getVendorPaymentRequestDetail}?payment_id=${payment_id}`;

    dispatch({
      type: VENDOR_PAYMENT_REQUEST_DETAIL,
      payload: {},
    });
    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: VENDOR_PAYMENT_REQUEST_DETAIL,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: VENDOR_PAYMENT_REQUEST_DETAIL,
      payload: {},
    });
  }
};

export const approvalVendorPaymentRequest = (requestData) => async()=>{
  // console.log(requestData); return false;
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.preSalesList.approvalVendorPaymentRequest
  );
  if (res?.data?.response.status === true) {
    const { data } = res;
    return data;
  }
};

export const approveHoldRequest = (requestData) => async()=>{
  // console.log(request);
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.preSalesList.approveHoldRequest
  );
  if (res?.data?.response.status === true) {
    const { data } = res;
    return data;
  }
};

export const getInvoiceRequestList = (queryObj = null, page = 1,is_pagination_required=true,pageSize=15) => async (dispatch) => {
  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `?page=${encodeURIComponent(page)}`
    + `&is_pagination_required=${encodeURIComponent(is_pagination_required)}`
    + `&pageSize=${encodeURIComponent(pageSize)}`;

    if (queryObj.fromDate !== undefined) {
        filterQuery += `&from_date=${encodeURIComponent(queryObj.fromDate)}`;
    }
    if (queryObj.toDate !== undefined) {
        filterQuery += `&to_date=${encodeURIComponent(queryObj.toDate)}`;
    }
    if (queryObj.invoice_number !== undefined) {
        filterQuery += `&invoice_number=${encodeURIComponent(queryObj.invoice_number)}`;
    }
    if (queryObj.vendor_name !== undefined) {
      filterQuery += `&vendor_name=${encodeURIComponent(queryObj.vendor_name)}`;
    }
    if (queryObj.status_id !== undefined) {
        filterQuery += `&status_id=${encodeURIComponent(queryObj.status_id)}`;
    }
  }
  try {
    dispatch({
      type: INVOICE_REQUEST_LIST,
      payload: {},
    });
    let apiUrl=(filterQuery!="")?
                `${Config.preSalesList.vendorInvoiceRequestList}${filterQuery}`:
                `${Config.preSalesList.vendorInvoiceRequestList}?page=${page}&is_pagination_required=${is_pagination_required}&pageSize=${pageSize}`;

    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );
    if (res) {
      const { data } = res;
      dispatch({
        type: INVOICE_REQUEST_LIST,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch(err) {
    dispatch({
      type: INVOICE_REQUEST_LIST,
      payload: {},
    });
  }
};

export const getInvoiceRequestDetail = (id) => async(dispatch)=>{
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.preSalesList.vendorInvoiceRequestDetails}?id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: INVOICE_REQUEST_DETAILS, payload: data.response.data });
    return true;
  }
};

export const getRequestedInvoiceRequestDetail = (request_id,vendor_id) => async(dispatch)=>{
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.preSalesList.invoiceRequestDetails}?request_id=${request_id}&vendor_id=${vendor_id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: REQUEST_INVOICE_REQUEST_DETAILS, payload: data.response.data });
    return true;
  }
};

const extractErrorMessage = (data, fallback = 'Request failed') => {
  if (!data) return fallback;
  const errors = data.errors || data.response?.errors;
  if (errors && typeof errors === 'object') {
    const messages = Object.values(errors).flat().filter(Boolean);
    if (messages.length) return messages.join(' ');
  }
  return data.message || data.response?.message || fallback;
};

const parseV2Data = (res) => {
  if (res?.data?.status === 0) {
    return { success: true, data: res.data.data, message: res.data.message };
  }
  if (res?.data?.response?.status === true) {
    return { success: true, data: res.data.response.data, message: res.data.response.message };
  }
  return {
    success: false,
    data: null,
    message: extractErrorMessage(res?.data),
    errors: res?.data?.errors || res?.data?.response?.errors,
  };
};

export const getVendorBankDetailFields = () => async () => {
  const res = await callWebService(
    callTypes.get,
    '',
    Config.preSalesList.getVendorBankDetailFields
  );
  return parseV2Data(res);
};

export const getGeoCitiesByState = (geoStateId) => async () => {
  if (!geoStateId) {
    return { success: true, data: [] };
  }
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.preSalesList.fetchGeoCity}?geo_state_id=${geoStateId}`
  );
  return parseV2Data(res);
};

export const getGeoPincodesByCity = (geoCityId) => async () => {
  if (!geoCityId) {
    return { success: true, data: [] };
  }
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.preSalesList.fetchGeoPincode}?geo_city_id=${geoCityId}`
  );
  return parseV2Data(res);
};

export const addVendorBankDetail = (payload) => async () => {
  try {
    const res = await callWebService(
      callTypes.post,
      payload,
      Config.preSalesList.addVendorBankDetail
    );
    const parsed = parseV2Data(res);
    return parsed.success
      ? { success: true, data: parsed.data, message: parsed.message }
      : parsed;
  } catch (error) {
    return {
      success: false,
      data: null,
      message: extractErrorMessage(
        error?.response?.data,
        error?.message || 'Failed to add bank detail'
      ),
      errors: error?.response?.data?.errors,
    };
  }
};

export const getVendorAddressFields = (addressId = null, vendorId = null) => async (dispatch) => {
  const params = [];
  if (addressId) params.push(`address_id=${addressId}`);
  if (vendorId) params.push(`vendor_id=${vendorId}`);
  const url = params.length
    ? `${Config.preSalesList.getVendorAddressFields}?${params.join('&')}`
    : Config.preSalesList.getVendorAddressFields;
  const res = await callWebService(callTypes.get, '', url);
  return parseV2Data(res);
};

export const addVendorAddress = (payload) => async () => {
  try {
    const res = await callWebService(
      callTypes.post,
      payload,
      Config.preSalesList.addVendorAddress
    );
    const parsed = parseV2Data(res);
    return parsed.success
      ? { success: true, data: parsed.data, message: parsed.message }
      : parsed;
  } catch (error) {
    return {
      success: false,
      data: null,
      message: extractErrorMessage(
        error?.response?.data,
        error?.message || 'Failed to add vendor address'
      ),
      errors: error?.response?.data?.errors,
    };
  }
};

export const editVendorAddress = (payload) => async () => {
  try {
    const res = await callWebService(
      callTypes.post,
      payload,
      Config.preSalesList.editVendorAddress
    );
    const parsed = parseV2Data(res);
    return parsed.success
      ? { success: true, data: parsed.data, message: parsed.message }
      : parsed;
  } catch (error) {
    return {
      success: false,
      data: null,
      message: extractErrorMessage(
        error?.response?.data,
        error?.message || 'Failed to update vendor address'
      ),
      errors: error?.response?.data?.errors,
    };
  }
};

export const getVendorDepartment = () => async(dispatch)=>{
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.preSalesList.getVendorDepartments}`
  );
  if (res) {
    const { data } = res;
    dispatch({ 
      type: GET_VENDOR_DEPARTMENTS, 
      payload: data.response.data
    });
    return true;
  }
};
